<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <a href="." class="link">A default coloured link</a>
    <a href="." class="link link-dark">A dark coloured link</a>
    <a href="." class="link link-light">A light/white coloured link</a>
  `;
</script>

<template>
  <section id="link" class="page-section bg-sageGreen40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Link</h2>
      <div class="space-y-4">
        <div>
          <a href="." class="link">A default coloured link</a>
        </div>
        <div>
          <a href="." class="link link-dark">A dark coloured link</a>
        </div>
        <div>
          <a href="." class="link link-light">A light/white coloured link</a>
        </div>
        <CodeSnippet id="link" {snippet} />
      </div>
    </div>
  </section>
</template>
